<template>
  <div>
    <ButtonTemplateMicInput text-button="연설자 설정" @click="toggleUserModal">
      <template #icon-handler>
        <IconUser />
      </template>
    </ButtonTemplateMicInput>

    <!-- 유저맵핑모달 -->
    <teleport to="body">
      <ModalSmall v-if="isVisibleUserModal" title="연설자 설정" @close="toggleUserModal">
        <div class="container-mapping-table">
          <div class="container-mapping-table">
            <h4 class="accent">연설자</h4>
            <div class="form-user">
              <input v-model="createSubUserForm.nickname" type="text" @keypress.enter="requestUpdateSubUser" />
              <button type="button" class="btn" @click="requestUpdateSubUser">생성</button>
            </div>
            <h4 class="accent">연설자 목록</h4>
            <TableDynamic
              :columns="userTableColumns"
              :rows="mcsStore.subUserList"
              :show-column-titles="true"
              :show-more-button="false"
              @deleteClick="requestDeleteSubUser"
            />
          </div>
        </div>
      </ModalSmall>
    </teleport>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';

import ButtonTemplateMicInput from '@/components/domains/chat/common/ButtonTemplateMicInput.vue';
import IconUser from '@/components/icons/IconUser.vue';
import TableDynamic from '@/components/shared/base/TableDynamic.vue';
import ModalSmall from '@/components/shared/composite/ModalSmall.vue';
import { useMcsStore } from '@/stores/mcs';
import { IRequestCreateMcsSubuser } from '@/types/request';

const route = useRoute();

const userTableColumns = [
  { key: 'loginId', label: '아이디', class: 'width40' },
  {
    key: 'nickname',
    label: '닉네임',
    class: 'width50',
  },
  { type: 'delete' },
];

const isVisibleUserModal = ref<boolean>(false); // 모달 노출 여부
const mcsStore = useMcsStore();

const createSubUserForm = ref<IRequestCreateMcsSubuser>({ nickname: '' }); // 유저 생성폼

const code = computed<string>(() => {
  return (route.params.code || '').toString();
});

const toggleUserModal = () => {
  isVisibleUserModal.value = !isVisibleUserModal.value;
};

// 유저 생성
const requestUpdateSubUser = async () => {
  if (!createSubUserForm.value.nickname) {
    return;
  }
  await mcsStore.requestUpdateSubUser(code.value, createSubUserForm.value);
  createSubUserForm.value.nickname = '';
};

// 유저 삭제
const requestDeleteSubUser = async (row) => {
  if (!row.loginId) {
    return;
  }
  await mcsStore.requestDeleteSubUser(code.value, row.loginId);
};

onMounted(async () => {
  await mcsStore.requestSubUserList(code.value);
});
</script>

<style scoped lang="scss">
::v-deep(.dynamic-table) {
  min-width: unset;
}

.container-mapping-table {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.wrapper-buttons {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  align-self: flex-end;
}

.form-user {
  display: flex;
  gap: 0.5rem;
}
.icon-handler {
  svg {
    width: 1.5rem !important;
    height: 1.5rem !important;
  }
}
</style>
